var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.enabled)?_c('q-tooltip',_vm._b({attrs:{"anchor":_vm.anchor,"self":_vm.self,"max-width":_vm.maxWidth,"content-class":'ws-tooltip ' + (_vm.onDark ? 'ws-tooltip--on-dark ' : '') + _vm.arrowClass,"offset":_vm.offset}},'q-tooltip',_vm.$attrs,false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }